import React from "react";
import moment from "moment";
import Box from "@material-ui/core/Box";
import DayContent from "./DayContent";

const DaysContent = ({ classes, ...rest }) => {
  const {
    startDate,
    events,
    onEditClickedCallback,
    onDuplicateClickedCallback,
    onCancelClickedCallback,
    onArchiveClickedCallback,
    onPreviewClickedCallback,
    onUnarchiveClickedCallback,
    onPublishClickedCallback,
  } = rest;

  const renderCell = (i, idx) => {
    const date = moment(startDate).add(idx, "days");
    return (
      <DayContent
        classes={classes}
        key={idx}
        date={date}
        idx={idx}
        today={date.format("YY-M-D") === moment().format("YY-M-D")}
        events={events[date.format("M/D/YYYY")] || []}
        onEditClickedCallback={onEditClickedCallback}
        onDuplicateClickedCallback={onDuplicateClickedCallback}
        onCancelClickedCallback={onCancelClickedCallback}
        onArchiveClickedCallback={onArchiveClickedCallback}
        onPreviewClickedCallback={onPreviewClickedCallback}
        onUnarchiveClickedCallback={onUnarchiveClickedCallback}
        onPublishClickedCallback={onPublishClickedCallback}
      />
    );
  };

  return <Box className={classes.days}>{[...Array(28)].map(renderCell)}</Box>;
};

export default DaysContent;
